
export enum AccountStatus {
    Disabled = 0,
    Active = 1,
    Barred = 2,
    Prospective = 3
}

export enum AvailableAccountStatus {
    Disabled = 0,
    Active = 1,
    Barred = 2
}
